// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__Ena4D","alertIcon":"ConfirmModal_alertIcon__3KDci"};